import React from 'react'
import styled from 'styled-components'
import facebookIcon from '../svg/facebook-icon.svg'
import instagramIcon from '../svg/instagram-icon.svg'
import linkedinIcon from '../svg/linkedin-icon.svg'

const SocialLinks = styled.div`
  z-index: 1000;
  position: fixed;
  top: 35%;
  right: 1%;
  display: flex;
  flex-direction: column;
  transform-origin: 0 100%;
  transition: all 0.5s;

  @media (min-width: 1200px) {
    right: ${props => (
      props.path === '/en/about/' || props.path === '/ru/about/'
        ? '20px' : '1%'
    )};
    width: ${props => (
      props.path === '/en/about/' || props.path === '/ru/about/'
        ? '50px' : 'auto'
    )};
    height: ${props => (
      props.path === '/en/about/' || props.path === '/ru/about/'
        ? '170px' : 'auto'
    )};
    transform: ${props => (
      props.path === '/en/about/' || props.path === '/ru/about/'
        ? 'rotate(-90deg)' : 'none'
    )};
  }
`

const Icon = styled.a`
  cursor: pointer;
  display: block;
  margin: auto;
  width: 25px;
  height: 25px;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  border: 1px solid white;
  border-radius: 50%;
  transition: all 0.5s;

  @media (min-width: 1200px) {
    transform: ${props => (
      props.path === '/en/about/' || props.path === '/ru/about/'
        ? 'rotate(90deg)' : 'none'
    )};
  }
`

const Divider = styled.span`
  margin: 5px auto;
  width: 1px;
  height: 15px;
  background-color: #979797;
`

const InstagramLink = styled(Icon)`
  background-image: url(${instagramIcon});
`

const LinkedInLink = styled(Icon)`
  background-image: url(${linkedinIcon});
`

const FacebookLink = styled(Icon)`
  background-image: url(${facebookIcon});
`

export default ({ path }) => (
  <SocialLinks path={path}>
    <InstagramLink
      href="https://www.instagram.com/goloobeff/"
      target="_blank"
      path={path}
    />
    <Divider />
    <FacebookLink
      href="https://www.facebook.com/dmitry.golubev.712"
      target="_blank"
      path={path}
    />
    <Divider />
    <LinkedInLink
      path={path}
    />
  </SocialLinks>
)



// WEBPACK FOOTER //
// ./src/components/social.js